function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Object, visibility) {
    var h = require("panel").h;
    const verticalAlignment = $helpers.getAlignmentConstants().vertical;
    return {
      value: (h("div", {
        "on": {
          click: e => e.stopPropagation()
        },
        "class": Object.assign({}, {
          'mp-modal-absolute': $attr(`not-fullscreen`),
          'mp-modal-closed': visibility === 'closed',
          'mp-modal-size-constraints': !$attr(`grow-to-content`),
        }, {
          'mp-modal-stage': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($helpers.getType() === 'modal') ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "on": {
              click: $helpers.backdropClicked
            },
            "class": Object.assign({}, {
              [`mp-modal-${visibility}`]: true
            }, {
              'mp-modal-backdrop': true
            }),
          }));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": Object.assign({}, {
            'mp-modal-top-aligned': $attr(`vertical-alignment`) === verticalAlignment.TOP,
            'mp-modal-bottom-aligned': $attr(`vertical-alignment`) === verticalAlignment.BOTTOM,
            'mp-modal-scrollable': $attr(`scrollable`),
          }, {
            'mp-modal-wrapper': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "attrs": {
              role: `dialog`,
              'aria-labelledby': $attr(`modal-title`),
              'aria-describedby': $attr(`modal-description`),
              'aria-modal': true,
            },
            "class": Object.assign({}, {
              [`mp-modal-${visibility}`]: true
            }, {
              'mp-modal-main': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(($attr(`closeable`) && !$attr(`hide-close-button`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": {
                  theme: `tertiary`,
                  icon: `x`,
                  size: `small`,
                },
                "on": {
                  click: $helpers.closeClicked
                },
                "class": {
                  'mp-modal-close-btn': true
                },
              }));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("slot"));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "visibility" in locals ? locals.visibility : typeof visibility !== "undefined" ? visibility : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;